import React from "react";

const TopHeader = ({ select }) => {
  return (
    <>
      <div className="bg-white border-b px-4 md:px-6 py-4 md:py-5">
        <h1 className="text-xl md:text-2xl font-bold">Add Single Catalog</h1>

        <div className="flex gap-6 md:gap-10 mt-4 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <div
              className={`w-6 h-6 md:w-7 md:h-7 ${select === 1 ? "bg-indigo-600 text-white" : "bg-gray-200"}  rounded-full flex items-center justify-center text-xs`}
            >
              1
            </div>
            Select Category
          </div>

          <div className="flex items-center gap-2 text-gray-400">
            <div
              className={`w-6 h-6 md:w-7 md:h-7 ${select === 2 ? "bg-indigo-600 text-white" : "bg-gray-200"}   rounded-full flex items-center justify-center text-xs`}
            >
              2
            </div>
            Add Product Details
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
